import type { FillInputProps } from '../fillInput';
import { Checkbox } from '@mui/material';

export const CheckboxInput = (props: FillInputProps<boolean, object>) => {
  const { inputId, describedBy, value, onChange, disabled, required, error } = props;
  return (
    <Checkbox
      id={inputId}
      checked={value}
      onChange={event => onChange(event.target.checked)}
      disabled={disabled}
      slotProps={{
        input: {
          'aria-describedby': describedBy,
          'aria-required': required || undefined,
          'aria-invalid': error || undefined,
        },
      }}
      sx={{ color: error ? 'error.main' : undefined }}
    />
  );
};
